import type {
    BillingRule,
    NewBillingRuleResponse,
    BillingResponse,
    NewBillingRule,
} from '@thinkalpha/locates-ws-client';
import { lapi as axios } from 'src/api';

export const getAllBillingRules = () => {
    return axios.get<BillingResponse>(`/v1/billing`).then((x) => x.data);
};

export const getAllFirmBillingRules = (firmId: string) => {
    return axios.get<BillingResponse>(`/v1/billing/firm/${firmId}`).then((x) => x.data);
};

export const createBillingRule = (billingRule: NewBillingRule): Promise<NewBillingRuleResponse> => {
    return axios.post<NewBillingRuleResponse>(`/v1/billing`, billingRule).then((x) => x.data);
};

export const updateBillingRule = (billingRule: BillingRule): Promise<NewBillingRuleResponse> => {
    return axios.patch<NewBillingRuleResponse>(`/v1/billing/${billingRule.id}`, billingRule).then((x) => x.data);
};

export const deleteBillingRule = (billingRule: BillingRule): Promise<NewBillingRuleResponse> => {
    return axios.delete<NewBillingRuleResponse>(`/v1/billing/${billingRule.id}`).then((x) => x.data);
};

// TODO: accounts for subject
// return getAccountsForSubject({ subjectId: firmId, forWhomType: 'firm' });
